export default {
  ModLogin: {
    email: 'Correo electrónico',
    password: 'Contraseña',
    register: 'Registrarse',
    account: 'Cuenta',
    login: 'Iniciar sesión',
    send_magic_link: 'Enviar enlace mágico',
    name: 'Nombre',
    send: 'enviar',
    super: 'Super',
    or: 'o',
  },
  ModTerms: {
    privacy_policy: 'Política de privacidad',
    last_updated: 'Actualizado el %{date}',
    accept: 'Aceptar',
    decline: 'Rechazar',
    delete: 'ELIMINAR CUENTA',
    go_back: 'VOLVER',
    are_you_sure: '¿Estás seguro?',
    are_you_sure_body:
      'Al rechazar los términos actualizados, tu cuenta y todos los datos asociados serán eliminados.',
    terms_updated: 'Hemos actualizado nuestros términos',
    terms_of_use:
      'MARKDOWN:[Términos de uso y Política de privacidad](https://www.ducky.eco/es/support/terms-of-use-for-the-ducky-challenge)',
  },
  ModRegister: {
    i_have_read: 'He leído y entendido los',
    terms_of_use: 'Términos de uso y Política de privacidad',
    or: 'o',
  },
  NavBar: {
    support: 'Soporte',
    products: 'Productos',
    find_tools: 'Encuentra tus herramientas',
    logIn: 'Iniciar sesión',
    menu: 'Menú',
    register: 'Registrar cuenta',
    contact_us: 'Contáctanos',
    your_tools: 'Tus herramientas',
    faq: 'Preguntas frecuentes',
    ProMen2: {
      active_since: 'Activo desde',
      log_out: 'Cerrar sesión',
      profile: 'Editar tu perfil',
    },
  },
  network_status_notification:
    'Estás sin conexión. Por favor, revisa tu internet.',
  error_boundary: {
    title: '¡Ups! Algo ha salido mal',
    body: 'Nuestro detective no pudo resolver el caso',
    button_text: 'intentar de nuevo',
  },
  not_found: {
    title: 'No podemos encontrar esta página',
    body: '',
    button_text: 'Volver a la línea de tiempo',
  },
};
